/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  Category,
  CategoryEnumerableResponse,
  CompleteAvailabilityListImageUploadRequest,
  DeleteAvailabilityListImageRequest,
  DeleteAvailabilityListParams,
  ResponseBase,
  StartAvailabilityListImageUploadRequest,
  StartAvailabilityListImageUploadResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useGetAvailabilityListsHook = () => {
        const getAvailabilityLists = useCustomInstance<CategoryEnumerableResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getAvailabilityLists(
          {url: `/AvailabilityListsAdmin/Index`, method: 'GET', signal
    },
          );
        }, [getAvailabilityLists])
      }
    

export const getGetAvailabilityListsQueryKey = () => {
    return [`/AvailabilityListsAdmin/Index`] as const;
    }

    
export const useGetAvailabilityListsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailabilityListsQueryKey();

  const getAvailabilityLists =  useGetAvailabilityListsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>> = ({ signal }) => getAvailabilityLists(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailabilityListsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>>
export type GetAvailabilityListsQueryError = unknown


export function useGetAvailabilityLists<TData = Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailabilityLists<TData = Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailabilityLists<TData = Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailabilityLists<TData = Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAvailabilityListsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAvailabilityListsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useUpsertAvailabilityListHook = () => {
        const upsertAvailabilityList = useCustomInstance<ResponseBase>();

        return useCallback((
    category: Category,
 signal?: AbortSignal
) => {
        return upsertAvailabilityList(
          {url: `/AvailabilityListsAdmin/UpsertAvailabilityList`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: category, signal
    },
          );
        }, [upsertAvailabilityList])
      }
    


export const useUpsertAvailabilityListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>, TError,{data: Category}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>, TError,{data: Category}, TContext> => {

const mutationKey = ['upsertAvailabilityList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const upsertAvailabilityList =  useUpsertAvailabilityListHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>, {data: Category}> = (props) => {
          const {data} = props ?? {};

          return  upsertAvailabilityList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAvailabilityListMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>>
    export type UpsertAvailabilityListMutationBody = Category
    export type UpsertAvailabilityListMutationError = unknown

    export const useUpsertAvailabilityList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>, TError,{data: Category}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpsertAvailabilityListHook>>>,
        TError,
        {data: Category},
        TContext
      > => {

      const mutationOptions = useUpsertAvailabilityListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteAvailabilityListHook = () => {
        const deleteAvailabilityList = useCustomInstance<ResponseBase>();

        return useCallback((
    params?: DeleteAvailabilityListParams,
 ) => {
        return deleteAvailabilityList(
          {url: `/AvailabilityListsAdmin/DeleteAvailabilityList`, method: 'DELETE',
        params
    },
          );
        }, [deleteAvailabilityList])
      }
    


export const useDeleteAvailabilityListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>, TError,{params?: DeleteAvailabilityListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>, TError,{params?: DeleteAvailabilityListParams}, TContext> => {

const mutationKey = ['deleteAvailabilityList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAvailabilityList =  useDeleteAvailabilityListHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>, {params?: DeleteAvailabilityListParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAvailabilityList(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAvailabilityListMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>>
    
    export type DeleteAvailabilityListMutationError = unknown

    export const useDeleteAvailabilityList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>, TError,{params?: DeleteAvailabilityListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListHook>>>,
        TError,
        {params?: DeleteAvailabilityListParams},
        TContext
      > => {

      const mutationOptions = useDeleteAvailabilityListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useStartAvailabilityListImageUploadHook = () => {
        const startAvailabilityListImageUpload = useCustomInstance<StartAvailabilityListImageUploadResponse>();

        return useCallback((
    startAvailabilityListImageUploadRequest: StartAvailabilityListImageUploadRequest,
 signal?: AbortSignal
) => {
        return startAvailabilityListImageUpload(
          {url: `/AvailabilityListsAdmin/StartAvailabilityListImageUpload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startAvailabilityListImageUploadRequest, signal
    },
          );
        }, [startAvailabilityListImageUpload])
      }
    


export const useStartAvailabilityListImageUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>, TError,{data: StartAvailabilityListImageUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>, TError,{data: StartAvailabilityListImageUploadRequest}, TContext> => {

const mutationKey = ['startAvailabilityListImageUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const startAvailabilityListImageUpload =  useStartAvailabilityListImageUploadHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>, {data: StartAvailabilityListImageUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  startAvailabilityListImageUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartAvailabilityListImageUploadMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>>
    export type StartAvailabilityListImageUploadMutationBody = StartAvailabilityListImageUploadRequest
    export type StartAvailabilityListImageUploadMutationError = unknown

    export const useStartAvailabilityListImageUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>, TError,{data: StartAvailabilityListImageUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useStartAvailabilityListImageUploadHook>>>,
        TError,
        {data: StartAvailabilityListImageUploadRequest},
        TContext
      > => {

      const mutationOptions = useStartAvailabilityListImageUploadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useCompleteAvailabilityListImageUploadHook = () => {
        const completeAvailabilityListImageUpload = useCustomInstance<ResponseBase>();

        return useCallback((
    completeAvailabilityListImageUploadRequest: CompleteAvailabilityListImageUploadRequest,
 signal?: AbortSignal
) => {
        return completeAvailabilityListImageUpload(
          {url: `/AvailabilityListsAdmin/CompleteAvailabilityListImageUpload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeAvailabilityListImageUploadRequest, signal
    },
          );
        }, [completeAvailabilityListImageUpload])
      }
    


export const useCompleteAvailabilityListImageUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>, TError,{data: CompleteAvailabilityListImageUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>, TError,{data: CompleteAvailabilityListImageUploadRequest}, TContext> => {

const mutationKey = ['completeAvailabilityListImageUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const completeAvailabilityListImageUpload =  useCompleteAvailabilityListImageUploadHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>, {data: CompleteAvailabilityListImageUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  completeAvailabilityListImageUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteAvailabilityListImageUploadMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>>
    export type CompleteAvailabilityListImageUploadMutationBody = CompleteAvailabilityListImageUploadRequest
    export type CompleteAvailabilityListImageUploadMutationError = unknown

    export const useCompleteAvailabilityListImageUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>, TError,{data: CompleteAvailabilityListImageUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCompleteAvailabilityListImageUploadHook>>>,
        TError,
        {data: CompleteAvailabilityListImageUploadRequest},
        TContext
      > => {

      const mutationOptions = useCompleteAvailabilityListImageUploadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteAvailabilityListImageHook = () => {
        const deleteAvailabilityListImage = useCustomInstance<ResponseBase>();

        return useCallback((
    deleteAvailabilityListImageRequest: DeleteAvailabilityListImageRequest,
 signal?: AbortSignal
) => {
        return deleteAvailabilityListImage(
          {url: `/AvailabilityListsAdmin/DeleteAvailabilityListImage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deleteAvailabilityListImageRequest, signal
    },
          );
        }, [deleteAvailabilityListImage])
      }
    


export const useDeleteAvailabilityListImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>, TError,{data: DeleteAvailabilityListImageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>, TError,{data: DeleteAvailabilityListImageRequest}, TContext> => {

const mutationKey = ['deleteAvailabilityListImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAvailabilityListImage =  useDeleteAvailabilityListImageHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>, {data: DeleteAvailabilityListImageRequest}> = (props) => {
          const {data} = props ?? {};

          return  deleteAvailabilityListImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAvailabilityListImageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>>
    export type DeleteAvailabilityListImageMutationBody = DeleteAvailabilityListImageRequest
    export type DeleteAvailabilityListImageMutationError = unknown

    export const useDeleteAvailabilityListImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>, TError,{data: DeleteAvailabilityListImageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAvailabilityListImageHook>>>,
        TError,
        {data: DeleteAvailabilityListImageRequest},
        TContext
      > => {

      const mutationOptions = useDeleteAvailabilityListImageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    